// Mục "Giữ chân": chuỗi điểm danh hiện tại (thanh ngang), quay lại D1/D7, người mới điểm danh lần đầu theo ngày.
import { Card, Col, Progress, Row } from "antd";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { faRotateLeft, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import XuEmptyHint from "./xu-empty-hint";
import XuKpiCard from "./xu-kpi-card";
import { shortDate, useXuChart } from "./xu-chart-style";
import { fmtNum, fmtPct } from "./xu-format-helpers";

function StreakBars({ streaks }) {
    if (!streaks.holders) return <XuEmptyHint compact title="Chưa ai đang giữ chuỗi" hint="Người điểm danh hôm nay hoặc hôm qua mới được tính." />;
    return (
        <div className="space-y-3">
            {streaks.buckets.map((b) => (
                <div key={b.key}>
                    <div className="flex justify-between text-sm mb-1">
                        <span>{b.label}</span>
                        <span><b>{fmtNum(b.users)}</b> người <span className="text-gray-400">({fmtPct(b.pct)})</span></span>
                    </div>
                    <Progress percent={b.pct || 0} showInfo={false} size="small" strokeColor="#16A34A" />
                </div>
            ))}
        </div>
    );
}

const retSub = (r) => (r.base ? `${fmtNum(r.returned)}/${fmtNum(r.base)} người quay lại` : "Chưa đủ ngày để đo");

export default function XuStatsRetentionSection({ overview }) {
    const { chart, tooltip } = useXuChart();
    const { retention, streaks } = overview;
    const { summary } = retention;
    const data = retention.cohorts.map((c) => ({ label: shortDate(c.vnDate), size: c.size }));
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={8}>
                <Card size="small" title="Chuỗi điểm danh hiện tại" className="shadow-sm h-full"><StreakBars streaks={streaks} /></Card>
            </Col>
            <Col xs={24} lg={16}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={8}>
                        <XuKpiCard icon={faUserPlus} tone="emerald" title="Điểm danh lần đầu" value={fmtNum(summary.newUsers)} unit="người" sub="Trong khoảng đang xem"
                            help="Người có ngày điểm danh thật đầu tiên rơi vào khoảng đang xem." />
                    </Col>
                    <Col xs={24} sm={8}>
                        <XuKpiCard icon={faRotateLeft} tone="indigo" title="Quay lại hôm sau (D1)" value={fmtPct(summary.d1.pct)} sub={retSub(summary.d1)}
                            help="Trong số người điểm danh lần đầu, bao nhiêu % điểm danh lại đúng ngày hôm sau. Ngày chưa tới thì chưa tính." />
                    </Col>
                    <Col xs={24} sm={8}>
                        <XuKpiCard icon={faRotateLeft} tone="purple" title="Quay lại sau 7 ngày (D7)" value={fmtPct(summary.d7.pct)} sub={retSub(summary.d7)}
                            help="% người điểm danh lại đúng 7 ngày sau lần đầu. Chỉ tính người đã đủ 7 ngày." />
                    </Col>
                    <Col xs={24}>
                        <Card size="small" title="Người điểm danh lần đầu theo ngày" className="shadow-sm">
                            {!summary.newUsers ? <XuEmptyHint compact title="Chưa có người mới nào điểm danh" /> : (
                                <ResponsiveContainer width="100%" height={150}>
                                    <BarChart data={data}>
                                        <CartesianGrid stroke={chart.grid} strokeDasharray="3 3" />
                                        <XAxis dataKey="label" stroke={chart.axis} fontSize={12} />
                                        <YAxis stroke={chart.axis} fontSize={12} allowDecimals={false} />
                                        <Tooltip {...tooltip} />
                                        <Bar dataKey="size" name="Người mới" fill={chart.series[2]} radius={[3, 3, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
